module.exports = __webpack_public_path__ + "img/right-icon.5977d1db.svg";